import { useEffect } from 'react';
import { isEmpty, isNil } from 'lodash-es';
import { delayHeavyTask } from 'client/site-modules/shared/utils/inp-utils';
import { useAppraisalTabsState } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/context/appraisal-tabs-context';

export function useStyleSelection({ vinStyles, wasFormSubmitted, isVinValid, isSubmitting, resetIsSubmitting }) {
  const {
    mmy,
    vin,
    vinDecoderStyles,
    setMmy: setContextMmy,
    setVinDecoderStyles: setContextVinDecoderStyles,
    setIsReadyForRedirect,
  } = useAppraisalTabsState();

  const currentFirstVinStyleId = !isEmpty(vinStyles) ? (vinStyles?.results?.[0]?.styleId ?? null) : undefined;

  useEffect(() => {
    setContextVinDecoderStyles(vinStyles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFirstVinStyleId]);

  const isReadyForUpdate = !!vinStyles && wasFormSubmitted && isVinValid && isSubmitting;
  const hasStyles = !!vinStyles && vinStyles?.results?.length;
  const decodedVinHasStyles = !!vinDecoderStyles?.results?.length;
  const isDecodedVinInvalid = wasFormSubmitted && isVinValid && !isNil(vinDecoderStyles) && !decodedVinHasStyles;

  useEffect(() => {
    if (isDecodedVinInvalid && isSubmitting) {
      resetIsSubmitting();
    }
  }, [isDecodedVinInvalid, isSubmitting, resetIsSubmitting]);

  useEffect(() => {
    if (!isReadyForUpdate || !hasStyles) {
      return;
    }

    const { makeNiceId: makeSlug, modelNiceId: modelSlug, year } = vinStyles?.results?.[0];
    setContextMmy({ make: makeSlug, model: modelSlug, year });
  }, [hasStyles, isReadyForUpdate, setContextMmy, vinStyles]);

  useEffect(() => {
    if (isReadyForUpdate && !isEmpty(mmy) && vin) {
      delayHeavyTask(() => {
        setIsReadyForRedirect(true);
      });
    }
  }, [isReadyForUpdate, mmy, setIsReadyForRedirect, vin]);

  return { isDecodedVinInvalid };
}
